import { createAnalyticsGroup } from 'js/lib/analytics'

export const track = createAnalyticsGroup('banners')